import React from 'react'

import MyDomainComponent from './my-domain'
import JoinedDomainComponent from './joined-domain'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import UserManageComponent from '../UserManageComponent'

const DomainComponent = () => {
  const location = useLocation()
  const settingsPath = location?.pathname === "/settings/access/users" ? true : false
  const settingsDomainPath = location?.pathname === "/settings/access/domains" ? true : false 
  return (
    <div className="domain-component">
      {!settingsPath && <MyDomainComponent settingsDomainPath={settingsDomainPath} />}
      {settingsPath && <UserManageComponent />}
      {settingsPath && <JoinedDomainComponent />}
    </div>
  )
}

export default DomainComponent